import React from 'react';
import { Equal } from 'tabler-icons-react';

export function MediumPriorityIcon() {
  return <Equal color="orange" size={20} />;
}
